import React from 'react';
import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';
import { Link } from 'react-router-dom';

const UserName = styled(({ banned, children, ...rest }) => (
  <Link {...rest}>{children}</Link>
))`
  font-size: 16px;
  color: ${props => (props.banned ? COLORS.gray40 : '#fff')};
  text-decoration: none;
  padding: 0 8px;
`;

export default UserName;
